<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <v-card class="pt-10">
          <v-form id="form" v-if="invoice">
            <v-container class="py-0 mt-0">
              <v-row>
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="12" md="6">
                      <h3>{{ $i18n.t("Invoice No") }}:</h3>
                    </v-col>
                    <v-col cols="12" md="6" v-if="!invEdit">
                      <h3>
                        {{ invoice.invoiceNo
                        }}<v-btn
                          color="grey"
                          small
                          text
                          v-if="!invEdit && invoice.status < 3 && !invoice.nonEditable"
                          class="bill-right-headers"
                          @click="invEdit = true"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </h3>
                    </v-col>
                    <v-col cols="12" md="6" v-else>
                      <v-text-field
                        dense
                        v-model="invoice.invoiceNo"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Invoice Date") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6" v-if="!invEdit">
                      <span>{{ formatDate(invoice.invoiceDate) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" v-else>
                      <z-date-picker dense v-model="invoice.invoiceDate" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Submission Date") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6" v-if="!invEdit">
                      <span>{{ formatDate(invoice.submitDate) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" v-else>
                      <z-date-picker dense v-model="invoice.submitDate" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Due Date") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6" v-if="!invEdit">
                      <span>{{ formatDate(invoice.dueDate) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" v-else>
                      <z-date-picker dense v-model="invoice.dueDate" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Entity") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.name }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.gstin">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("GSTIN") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.gstin }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      !invoice.vendorEntity.gstin && invoice.vendorConfig.gstin
                    "
                  >
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("GSTIN") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorConfig.gstin }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Name") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorName }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      !invoice.vendorEntity.address.addressLine &&
                      invoice.vendorAddress
                    "
                  >
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Address") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorAddress }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorPhone">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Phone") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.invoicePhone }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.invoiceEmail">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Email") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.invoiceEmail }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.serviceCode">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Service Account Code") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.serviceCode }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      !invoice.forIndividual &&
                      invoice.vendorEntity.corporate.pan
                    "
                  >
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("PAN") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.corporate.pan }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.corporate.cin">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("CIN") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.corporate.cin }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.corporate.epfo">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("EPFO") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.corporate.epfo }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.corporate.esic">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("ESIC") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.corporate.esic }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.stateCode">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("State Code") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.stateCode }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.vendorEntity.lutNo">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("LUT No") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.vendorEntity.lutNo }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer />
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="12" md="3">
                      <span>{{ $i18n.t("Status") }}:</span>
                    </v-col>
                    <v-col cols="12" md="3">
                      <span>{{ invoice.statusMessage }}</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="invoice.status"
                        :items="statusList"
                        @change="
                          getConfirmation(
                            $i18n.t('Update invoice status'),
                            updateStatus
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Created At") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{
                        invoice.createdAt | moment("DD MMM YYYY HH:MM A")
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.createdByName">
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Created By") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.createdByName }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Label") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.chargesLabel }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Trips Date Range") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{
                        formatDate(invoice.fromDate) +
                        " - " +
                        formatDate(invoice.toDate)
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Reference No.") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6" v-if="!invEdit">
                      <span>{{invoice.refNo}}</span>
                    </v-col>
                    <v-col cols="12" md="6" v-else>
                      <v-text-field
                        v-model="invoice.refNo"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>{{ $i18n.t("Miro No.") }}:</span>
                    </v-col>
                    <v-col cols="12" md="6" v-if="!invEdit">
                      <span>{{invoice.miroNo}}</span>
                    </v-col>
                    <v-col cols="12" md="6" v-else>
                      <v-text-field
                        v-model="invoice.miroNo"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <EInvoice :invoice_id="invoice._id" :invoiceStatus="invoice.status"></EInvoice>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-row >
                    <v-col cols="12" md="6" style="border: 1px solid red" class="py-5">
                      <v-row>
                        <v-col cols="12" md="12">
                          <b>{{ $i18n.t("Billed To") }}</b>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Details of Consignee") }}</span>
                        </v-col>
                        <v-col cols="12" md="6"></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Name") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6" v-if="!invoice.forIndividual">{{
                          invoice.clientName
                        }}</v-col>
                        <v-col cols="12" md="6" v-if="!invoice.forIndividual">
                          <!-- {{invoice.passenger.name}} -->
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="invoice.forIndividual && invoice.showPaxCompany"
                      >
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Company") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6">{{ invoice.clientName }}</v-col>
                      </v-row>
                      <v-row v-if="invoice.shippedToEntity&& invoice.shippedToEntity.address&& invoice.shippedToEntity.address.addressLine">
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Address") }}:</span>
                        </v-col>
                        <v-col v-if="invoice.clientEntity&& invoice.clientEntity.address" cols="12" md="6">
                          {{ invoice.clientEntity.address.addressLine }},
                          {{ invoice.clientEntity.address.city }},
                          {{ invoice.clientEntity.address.state }},
                          {{ invoice.clientEntity.address.country }}
                        </v-col>
                      </v-row>
                      <v-row v-if="!invoice.forIndividual">
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("PAN No") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6">{{
                          invoice.clientEntity.corporate.pan
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Billing State") }}:</span>
                        </v-col>
                        <v-col v-if="invoice.clientEntity&& invoice.clientEntity.address" cols="12" md="6">{{
                          invoice.clientEntity.address.state
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("State Code") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6">{{
                          invoice.clientEntity.stateCode
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{
                            $i18n.t("GSTIN") + "/" + $i18n.t("UNIQUE ID")
                          }}</span>
                        </v-col>
                        <v-col cols="12" md="6">{{
                          invoice.clientEntity.gstin
                        }}</v-col>
                      </v-row>
                      <v-row v-if="invoice.poNo">
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("PO No") }}</span>
                        </v-col>
                        <v-col cols="12" md="6">{{ invoice.poNo }}</v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" md="6" style="border: 1px solid red" class="py-5">
                      <v-row>
                        <v-col cols="12" md="12">
                          <b>{{ $i18n.t("Shipped To") }}</b>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Details of Receiver") }}</span>
                        </v-col>
                        <v-col cols="12" md="6"></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Name") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6" v-if="!invoice.forIndividual">{{
                          invoice.clientName
                        }}</v-col>
                        <v-col cols="12" md="6" v-if="!invoice.forIndividual">
                          <!-- {{invoice.passenger.name}} -->
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="invoice.forIndividual && invoice.showPaxCompany"
                      >
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Company") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6">{{ invoice.clientName }}</v-col>
                      </v-row>
                      <v-row v-if="invoice.shippedToEntity.address&& invoice.shippedToEntity.address.addressLine">
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Address") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6">
                          {{ invoice.shippedToEntity.address.addressLine }},
                          {{ invoice.shippedToEntity.address.city }},
                          {{ invoice.shippedToEntity.address.state }},
                          {{ invoice.shippedToEntity.address.country }}
                        </v-col>
                      </v-row>
                      <v-row v-if="!invoice.forIndividual">
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("PAN No") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6">{{
                          invoice.clientEntity.corporate.pan
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("Billing State") }}:</span>
                        </v-col>
                        <v-col v-if="invoice.shippedToEntity.address&& invoice.shippedToEntity.address.state" cols="12" md="6">{{
                          invoice.shippedToEntity.address.state
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("State Code") }}:</span>
                        </v-col>
                        <v-col cols="12" md="6">{{
                          invoice.shippedToEntity.stateCode
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <span>{{
                            $i18n.t("GSTIN") + "/" + $i18n.t("UNIQUE ID")
                          }}</span>
                        </v-col>
                        <v-col cols="12" md="6">{{
                          invoice.shippedToEntity.gstin
                        }}</v-col>
                      </v-row>
                      <v-row v-if="invoice.poNo">
                        <v-col cols="12" md="6">
                          <span>{{ $i18n.t("PO No") }}</span>
                        </v-col>
                        <v-col cols="12" md="6">{{ invoice.poNo }}</v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Trip(s) / Cargo(s)") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col
                          clos="12"
                          md="6"
                          v-if="invoiceEdit && invoice.creationMode != 0"
                        >
                          <v-btn
                            @click="openBookingModal"
                            small
                            style="width: 60px; float: right"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <thead>
                        <tr>
                          <th style="width: 25%">{{ $i18n.t("Item") }}</th>
                          <th style="width: 25%">
                            {{ $i18n.t("Trip") }} Detail
                          </th>
                          <th style="width: 20%">{{ $i18n.t("Charges") }}</th>
                          <th style="width: 13%">{{ $i18n.t("Discount") }}</th>
                          <th style="width: 12%">{{ $i18n.t("Tax") }}</th>
                          <th style="width: 15%">
                            {{ $i18n.t("Collection") }}
                          </th>
                          <th style="width: 10%">
                            {{ $i18n.t("Total") }}
                            ({{ invoice.fare.currency }})
                          </th>
                          <th>{{ $i18n.t("Action") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(tripInvoice, index) in invoice.tripInvoiceTOS"
                          :key="'tripInvoice' + index"
                        >
                          <td>
                            <span v-if="tripInvoice.trip != null">
                              <v-btn
                                small
                                v-if="tripInvoice.trip != null"
                                color="blue"
                                :to="'/trip/' + tripInvoice.trip_id"
                              >{{tripInvoice.trip.tripNo}}
                              </v-btn>
                              
                              <br />
                              LR No : {{getLrNo(tripInvoice)}}
                              <br />
                              Client LR No : {{getClientLrNo(tripInvoice)}}
                              <br />
                              Client Ref No : {{getClientRefNo(tripInvoice)}}
                              <br />
                              Goods Inv. No : {{getInvNo(tripInvoice)}}
                            </span>
                            <p
                              v-if="
                                tripInvoice.trip != null &&
                                tripInvoice.trip.groupBookingNo != null
                              "
                            >
                              {{ $i18n.t("Group Booking No") }}:
                              {{ tripInvoice.trip.groupBookingNo }}
                            </p>
                            <p
                              v-if="
                                tripInvoice.trip != null &&
                                tripInvoice.trip.merchantBookingCode != null
                              "
                            >
                              {{ $i18n.t("Merchant Booking Code") }}: #{{
                                tripInvoice.trip.merchantBookingCode
                              }}
                            </p>
                            <p
                              v-if="
                                tripInvoice.trip != null &&
                                tripInvoice.trip.supplierBookingCode != null
                              "
                            >
                              {{ $i18n.t("Supplier Booking Code") }}: #{{
                                tripInvoice.trip.supplierBookingCode
                              }}
                            </p>
                          </td>

                          <td>
                            <span v-if="tripInvoice.trip != null">
                              <p>
                                <i
                                  class="fa fa-flag-o"
                                  style="color: green"
                                ></i>
                                <span v-if="tripInvoice.trip.startedAt">
                                  {{
                                    tripInvoice.trip.startedAt
                                      | moment("DD MMM YYYY HH:MM A")
                                  }}
                                  |
                                </span>
                                {{
                                  tripInvoice.trip.tripSrc && tripInvoice.trip.tripSrc.addressLine
                                    ? tripInvoice.trip.tripSrc.addressLine + ","
                                    : ""
                                }}
                                {{
                                  tripInvoice.trip.tripSrc && tripInvoice.trip.tripSrc.city
                                    ? tripInvoice.trip.src.city + ","
                                    : ""
                                }}
                                {{
                                  tripInvoice.trip.tripSrc && tripInvoice.trip.tripSrc.country
                                    ? tripInvoice.trip.tripSrc.country
                                    : ""
                                }}
                              </p>
                            </span>
                            <span v-if="tripInvoice.trip != null">
                              <p>
                                <i class="fa fa-flag-o" style="color: red"></i>
                                <span v-if="tripInvoice.trip.stoppedAt">
                                  {{
                                    tripInvoice.trip.stoppedAt
                                      | moment("DD MMM YYYY HH:MM A")
                                  }}
                                  |
                                </span>
                                {{
                                  tripInvoice.trip.tripDst && tripInvoice.trip.tripDst.addressLine
                                    ? tripInvoice.trip.tripDst.addressLine + ","
                                    : ""
                                }}
                                {{
                                  tripInvoice.trip.tripDst && tripInvoice.trip.tripDst.city
                                    ? tripInvoice.trip.tripDst.city + ","
                                    : ""
                                }}
                                {{
                                  tripInvoice.trip.tripDst && tripInvoice.trip.tripDst.country
                                    ? tripInvoice.trip.tripDst.country
                                    : ""
                                }}
                              </p>
                            </span>
                            <span v-if="tripInvoice.trip != null">
                              <p>
                                <i class="fa fa-car"></i>
                                {{
                                  tripInvoice.vehicleTO.vehicleTypeStr
                                    ? tripInvoice.vehicleTO.vehicleTypeStr +
                                      " |"
                                    : ""
                                }}
                                {{
                                  tripInvoice.trip.vehicle.regNo
                                    ? tripInvoice.trip.vehicle.regNo
                                    : ""
                                }}
                              </p>
                            </span>
                            <span
                              v-if="
                                tripInvoice.trip != null &&
                                tripInvoice.trip.driver
                              "
                            >
                              <p>
                                <i class="fa fa-user"></i>
                                {{
                                  tripInvoice.trip.driver.name
                                    ? tripInvoice.trip.driver.name + " |"
                                    : ""
                                }}
                                {{
                                  tripInvoice.trip.driver.phone
                                    ? tripInvoice.trip.driver.phone
                                    : ""
                                }}
                              </p>
                            </span>
                            <span v-if="tripInvoice.desc != null">
                              <p>{{ tripInvoice.desc }}</p>
                            </span>
                          </td>

                          <td colspan="3">
                            <v-simple-table dense>
                              <tbody>
                                <tr
                                  v-for="(charge, index) in tripInvoice.fare
                                    .charges"
                                  :key="'it' + index"
                                >
                                  <td>
                                    <span v-if="charge.items"
                                      ><span
                                        v-for="(item, index) in charge.items"
                                        :key="'it' + index"
                                      >
                                        <p>
                                          {{ item.name }} : {{ item.amount }}
                                        </p>
                                        <p
                                          v-if="
                                            item.desc != null && item.desc != ''
                                          "
                                          style="
                                            font-size: 10px;
                                            margin-top: -7px;
                                          "
                                        >
                                          ({{ item.desc }})
                                        </p>
                                      </span></span
                                    >
                                  </td>
                                  <td>
                                    <span v-if="charge.discounts">
                                      <span
                                        v-for="(item, i) in charge.discounts"
                                        :key="'dsd' + i"
                                      >
                                        <p>
                                          {{ item.name }} : {{ item.amount }}
                                        </p>
                                      </span></span
                                    >
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        charge.taxItem && charge.taxItem.taxes
                                      "
                                      ><span
                                        v-for="(item, i) in charge.taxItem
                                          .taxes"
                                        :key="'dsd1' + i"
                                      >
                                        <p>
                                          {{ item.name }} : {{ item.amount }}
                                        </p>
                                      </span></span
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </td>

                          <td>
                            {{
                              tripInvoice.driverCollection
                                ? "Driver Collection :" + driverCollection
                                : ""
                            }}
                          </td>
                          <td class="text-right">
                            {{ tripInvoice.fare.total }}
                          </td>
                          <td v-if="invoiceEdit || true">

                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              v-if="index != 0"
                              @click="moveUp(invoice.tripInvoiceTOS, index)"
                            >
                              <v-icon>mdi-arrow-up-box</v-icon>
                            </v-btn>

                            <!-- <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="deleteTripInvoice(tripInvoice)"
                            >
                              <v-icon>mdi-trash-outlined</v-icon>
                            </v-btn> -->
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color: #f4feff">
                            <strong>
                              {{ $i18n.t("Total") }}
                              ({{ invoice.tripInvoiceTOS.length }})
                            </strong>
                          </td>
                          <td style="background-color: #f4feff"></td>
                          <td style="background-color: #f4feff" colspan="3">
                            <v-simple-table dense>
                              <tbody>
                                <tr
                                  v-for="(charge, index) in invoice.fare
                                    .charges"
                                  :key="'it' + index"
                                >
                                  <td>
                                    <span v-if="charge.items"
                                      ><span
                                        v-for="(item, index) in charge.items"
                                        :key="'it' + index"
                                      >
                                        <p>
                                          {{ item.name }} : {{ item.amount }}
                                        </p>
                                        <p
                                          v-if="
                                            item.desc != null && item.desc != ''
                                          "
                                          style="
                                            font-size: 10px;
                                            margin-top: -7px;
                                          "
                                        >
                                          ({{ item.desc }})
                                        </p>
                                      </span></span
                                    >
                                  </td>
                                  <td>
                                    <span v-if="charge.discounts">
                                      <span
                                        v-for="(item, i) in charge.discounts"
                                        :key="'dsd' + i"
                                      >
                                        <p>
                                          {{ item.name }} : {{ item.amount }}
                                        </p>
                                      </span></span
                                    >
                                  </td>
                                  <td>
                                    <span
                                      v-if="
                                        charge.taxItem && charge.taxItem.taxes
                                      "
                                      ><span
                                        v-for="(item, i) in charge.taxItem
                                          .taxes"
                                        :key="'dsd1' + i"
                                      >
                                        <p>
                                          {{ item.name }} : {{ item.amount }}
                                        </p>
                                      </span></span
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </td>
                          <td style="background-color: #f4feff"></td>
                          <td
                            style="background-color: #f4feff"
                            class="text-right"
                          >
                            <strong>{{ invoice.fare.total }}</strong>
                          </td>
                          <td
                            style="background-color: #f4feff"
                            v-if="invoiceEdit || true"
                          >
                            <!-- <span ng-show="invoiceEdit">
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#responsive_logo"
                              >
                                <button
                                  class="
                                    btn-u
                                    btn-u-xs
                                    btn-u-blue
                                    btn-brd
                                    btn-brd-hover
                                  "
                                >
                                  <i class="fa fa-plus"></i>
                                  {{ $i18n.t("Fare") }}
                                </button>
                              </a>
                            </span> -->
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-spacer />
                <v-col cols="12" md="4" class="text-right">
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>
                        <b>{{ $i18n.t("Sub Total") }}:</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.fare.subTotal }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="(item, i) in invoice.charges"
                    :key="'charges1' + i"
                  >
                    <v-col cols="12" md="6">
                      <span>{{ item.name }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ item.applied }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="(item, i) in invoice.discounts"
                    :key="'discounts1' + i"
                  >
                    <v-col cols="12" md="6">
                      <span>{{ item.name }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>(-) {{ item.applied }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>
                        <b>{{ $i18n.t("Total Discount") }}:</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.fare.totalDiscounts }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-for="(item, i) in invoice.taxes" :key="'taxes1' + i">
                    <v-col cols="12" md="6">
                      <span>{{ item.name }}{{ " " + item.desc }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>(-) {{ item.amount }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>
                        <b>{{ $i18n.t("Total Tax") }}:</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.fare.totalTaxes }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <span>
                        <b
                          >{{ $i18n.t("Total") }}({{
                            invoice.fare.currency
                          }}):</b
                        >
                      </span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span>{{ invoice.fare.total }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <z-confirm-button
                  color="red"
                  small
                  :message="$i18n.t('Do you want to cancel this invoice ?')"
                  v-if="!invEdit && (invoice.status == 0 || invoice.status == 1) && !invoice.nonEditable"
                  class="bill-right-headers"
                  @click="cancelInvoice()"
                >
                  <v-icon>mdi-cancel</v-icon> {{ $i18n.t("Cancel") }} 
                </z-confirm-button>
                <v-spacer />

                <v-btn
                  color="blue"
                  small
                  v-if="!updatedSerials"
                  class="bill-right-headers"
                  @click="updateTripsOrdering"
                >
                  {{ $i18n.t("Update Trips Ordering") }}
                </v-btn>

                <v-btn
                  color="orange"
                  small
                  v-if="!invEdit && invoice.status < 3 && !invoice.nonEditable"
                  class="bill-right-headers"
                  @click="invEdit = true"
                >
                  {{ $i18n.t("Edit Invoice") }}
                </v-btn>

                <v-btn
                  color="green"
                  small
                  v-if="invEdit && invoice.status < 3 && !invoice.nonEditable"
                  class="bill-right-headers"
                  @click="updateLimitedDetails"
                >
                  {{ $i18n.t("Save Invoice") }}
                </v-btn>
              </v-row>

              <!-- <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn color="info" class="mr-0" @click="createInvoice()" :loading="loading">
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>-->
            </v-container>
          </v-form>

          <v-col>
            <div v-html="invoicePolicyContent" class="text-size" />
            <v-btn
              color="cyan"
              style="float: right"
              x-small
              class="bill-right-headers"
              @click="showAddContent = true"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmationDialog" color="white" width="400">
      <v-card>
        <v-card-text>{{ confirmationDialogText }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text fab small @click="confirmationDialogFun()">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn color="red" text fab small @click="confirmationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddContent" transition="dialog-top-transition">
      <v-card>
        <v-toolbar dark color="secondary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-card-text</v-icon>
            {{ $i18n.t("Add/Edit Content") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showAddContent = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <static-content-edit
            :payload="{
              corp_id: invoice ? invoice.vendor_id : null,
              contentType: 'INVOICE_POLICY',
              fromDialog: true,
            }"
            @fetchContent="fetchInvoicePolicyContent()"
            @contentDialog="onContentDialogChange()"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import StaticContentEdit from "@/views/staticcontent/StaticContentEdit.vue";
import EInvoice from "./EInvoice.vue";
@Component({
  name: "ManualInvoice",
  components: { StaticContentEdit, EInvoice },
})
export default class ManualInvoice extends Vue {
  invoice = null;
  client = {};
  vendor = {};
  invoiceEdit = false;
  showAddContent = false;
  extraFare = { charges: [] };
  entityList = [];
  entityListClient = [];
  stateMap = {};
  confirmationDialogText = null;
  confirmationDialogFun = null;
  confirmationDialog = false;
  invoicePolicyContent = null;
  invEdit = null;
  statusList = [];

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onContentDialogChange(value) {
    this.showAddContent = value;
  }

  async fetchInvoicePolicyContent() {
    this.invoicePolicyContent = await doGet(
      "/api/static/content/render/INVOICE_POLICY"
    );
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.fetchInvoice(this.$route.params.id);
    }
    await this.fetchInvoicePolicyContent();
  }

  getConfirmation(text, fun) {
    this.confirmationDialogText = text;
    this.confirmationDialogFun = fun;
    this.confirmationDialog = true;
  }

  async fetchTaxList(client_id, vendor_id) {
    this.taxList = await doGet(
      "/api/corp/tax/client/" + client_id + "/vendor/" + vendor_id
    );
  }

  async fetchInvoice(_id) {
    common.setLoading(true);
    try {
      const response = await doGet("/api/invoice/" + _id + "/detail");
      common.setLoading(false);
      this.invoiceEdit = false;
      this.id = response._id;
      this.prepareInvoiceResponse(response);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  prepareInvoiceResponse(response) {
    if (response.collects && response.collects.length > 0) {
      for (let i = 0; i < response.collects.length; i++) {
        response.collects[i].mode = this.getMode(response.collects[i].mode);
      }
    }
    this.statusList = [];
    if (response.showMarkCreated) {
      this.statusList.push({ text: "Unverify", value: 0 });
    }
    if (response.showMarkVerified) {
      this.statusList.push({ text: "Verify", value: 1 });
    }
    if (response.showMarkPaid) {
      this.statusList.push({ text: "Payment Collected", value: 3 });
    }
    if (response.showMarkCancelled) {
      this.statusList.push({ text: "Cancelled", value: 4 });
    }
    this.invoice = response;
    this.invEdit = null;
  }

  getMode(mode) {
    if (!mode) return "";
    if (mode == 1) return "Cash";
    if (mode == 2) return "Cheque";
    if (mode == 3) return "Debit Card";
    if (mode == 4) return "Credit Card";
    if (mode == 5) return "UPI";
    if (mode == 6) return "Bank Transfer";
  }

  showCollectModal(invoice) {
    // if (invoice.status != 1 && invoice.status != 3) {
    // 	showError("Please select invoices of same status (verified)");
    //      throw "";
    //      return ;
    // }
    // let data = {};
    //   data.invoice_ids = invoice._id;
    // showAddPaymentDialog(data, function(response) {
    // 	if (response != null && response == 'success') {
    //         showMessage("Payment added successfully");
    // 				setTimeout(function () {
    // 					window.location.reload();
    // 				}, 2000);
    //      } else {
    //         showError(response);
    //      }
    // });
  }

  applyCCharge() {
    common.setLoading(true);
    const t = JSON.parse(Object.assign({}, this.applyCharge));
    if (!this.invoice.charges) this.invoice.charges = [];
    if (t) {
      const item = {};
      item.name = t.cardName;
      item.amount = t.amount;
      item.isAbs = t.isAbs;
      item.notTaxable = t.notTaxable;
      this.invoice.charges.push(item);
      this.saveCharges(this.invoice._id);
    }
    common.setLoading(false);
  }

  async fetchContractedChargesList() {
    const url =
      "/api/invoiceconfig/surcharges?client_id=" +
      this.invoice.client_id +
      "&clientEntity_id=" +
      this.invoice.clientEntity._id +
      "&vendor_id=" +
      this.invoice.vendor_id +
      "&vendorEntity_id=" +
      this.invoice.vendorEntity._id;
    this.contractedChargesList = await doGet(url);
  }

  invoiceCharges() {
    this.fetchContractedChargesList();
    this.invoiceChargesDialog = true;
  }

  async selectTax2(tax_id) {
    common.setLoading(true);
    try {
      this.invoice = await doPost(
        "/api/invoice/" + this.id + "/amend/tax/" + tax_id
      );
      this.taxTypeDetail_dialog2 = false;
      common.showMessage("Tax type Changed.");
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  addNewDutyToInvoice(booking) {
    // showConfirmDialog("Are you sure you want to add new duty(" + booking.bookingNo +") to this invoice ?", function () {
    // 	let url =  "/api/invoice/" + this.invoice._id + "/tripinvoice/" + booking._id + "/add";
    // 	common.setLoading(true);
    // 	let res = await doGet(url);
    // 	res.success(function(response) {
    // 		common.setLoading(false);
    // 		showMessage("Trip invoice added successfully.");
    // 			window.location.reload();
    // 	});
    // 	res.error(function(response, a) {
    // 		common.setLoading(false);
    // 		showError(response, a);
    // 	});
    // });
  }

  openBookingModal() {
    // let payload = {};
    // payload.status = '3,4,5,7,12,13';
    // payload.hideVendor = payload.hideClient = payload.hideSupplier = true;
    // payload.client_id = this.invoice.client_id;
    // payload.vendor_id = this.invoice.vendor_id;
    // showBookingSelectModal(payload, function (booking) {
    // 	this.addNewDutyToInvoice(booking);
    // });
  }

  async editTaxType(invoice_id) {
    try {
      this.taxDetail2 = await doGet("/api/taxslab/all");
      this.taxTypeDetail_dialog2 = true;
    } catch (e) {
      common.setError(e);
    }
  }

  async saveVendorEntity(invoice_id) {
    if (this.invoice.vendorEntity._id) {
      common.setLoading(true);
      try {
        const response = await doPost(
          "/api/invoice/" +
            invoice_id +
            "/save/vendor/entity/" +
            this.invoice.vendorEntity._id
        );
        this.invoiceEdit = false;
        this.prepareInvoiceResponse(response);
        common.setLoading(false);
        common.showMessage("Entity Changed.");
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async updateInvoiceNoDate(invoice_id) {
    if (this.invoice.invoiceNo && this.invoice.date) {
      common.setLoading(true);
      try {
        const url =
          "/api/invoice/" +
          invoice_id +
          "/update/invoice/num/" +
          this.invoice.invoiceNo +
          "/date/" +
          this.invoice.date;
        const response = await doGet(url);
        this.invoiceEdit = false;
        this.prepareInvoiceResponse(response);
        common.setLoading(false);
        common.showMessage("Invoice No and Date Changed.");
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async updateFromToDate(invoice_id) {
    if (this.invoice.fromDate && this.invoice.toDate) {
      common.setLoading(true);
      try {
        const url =
          "/api/invoice/" +
          invoice_id +
          "/updateDate/" +
          this.invoice.fromDate +
          "/" +
          this.invoice.toDate;
        const response = await doGet(url);
        this.invoiceEdit = false;
        this.prepareInvoiceResponse(response);
        common.setLoading(false);
        common.showMessage("Invoice From To Date Changed.");
      } catch (e) {
        common.setLoading(false);
        this.showError(e);
      }
    }
  }

  async updatePassenger(invoice_id) {
    // common.setLoading(true);
    // let url =  "/api/invoice/"+invoice_id+"/update/invoice/passenger";
    // if(this.invoice.passenger.address)
    // 	this.invoice.passenger.address.country = this.invoice.vendorEntity.address.country;
    // let res = await doPost(url, this.invoice.passenger);
    // res.success(function(response) {
    // 	this.shipToEdit = false;
    // 	this.invoice = response;
    // 	this.prepareInvoiceResponse(this.invoice);
    // 	common.setLoading(false);
    // 	showMessage("Individual Invoice Passenger Detail Updated.");
    // });
    // res.error(function(response, code) {
    // 	common.setLoading(false);
    // 	showError(response, code);
    // });
  }

  async saveChargesLabel(invoice_id) {
    if (!this.invoice.chargesLabel || this.invoice.chargesLabel.length < 10) {
      common.setError("Please provide charges label of atleast 10 characters.");
      return;
    }
    try {
      common.setLoading(true);
      const response = await doGet(
        "/api/invoice/" +
          invoice_id +
          "/update/charges/label?chargesLabel=" +
          this.invoice.chargesLabel
      );
      this.invoiceEdit = false;
      this.prepareInvoiceResponse(response);
      common.setLoading(false);
      common.showMessage("Invoice charges label updated.");
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async saveClientEntity(invoice_id) {
    if (this.invoice.clientEntity._id) {
      try {
        common.setLoading(true);
        const url =
          "/api/invoice/" +
          invoice_id +
          "/save/client/entity/" +
          this.invoice.clientEntity._id;
        const response = await doPost(url);
        this.billToEdit = false;
        this.prepareInvoiceResponse(response);
        common.setLoading(false);
        common.showMessage("Entity Changed.");
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  addAttachment() {
    // $('#invoiceAttachmentFormModel').modal('show');
    // let url = "/api/invoice/"+ invoice_id+ "/upload/signed/pdf ";
    // $('#invoiceAttachmentForm').attr('action', url);
  }

  // $("form#invoiceAttachmentForm").submit(function(event){

  // 	event.preventDefault();
  // 	let formData = new FormData($(this)[0]);

  // 	common.setLoading(true);

  //   $.ajax({
  //     url: $('#invoiceAttachmentForm').attr('action'),
  //     type: 'POST',
  //     data: formData,
  //     async: false,
  //     cache: false,
  //     contentType: false,
  //     processData: false,
  //     success: function (response) {

  //       $('#confirmationDialog').modal('show');
  //       let elem = document.getElementById("confirmationDialogLabel");
  //       elem.innerHTML = "File Uploaded Successfully.";
  //       elem.style.color = "Green";
  //       this.invoice.signedPDF = response.signedPDF;
  // 		  this.$apply();
  // 		  common.setLoading(false);
  //     },
  //     error : function (response){
  //       $('#confirmationDialog').modal('show');
  //       let elem = document.getElementById("confirmationDialogLabel");
  //       elem.innerHTML = response;
  //       elem.style.color = "Red";
  //   		common.setLoading(false);
  //     }
  //   });

  //   return false;
  // });

  async saveShippedEntity(invoice_id) {
    if (this.invoice.shippedEntity._id) {
      try {
        common.setLoading(true);
        const response = await doPost(
          "/api/invoice/" +
            invoice_id +
            "/save/shippedTo/entity/" +
            this.invoice.shippedEntity._id
        );
        this.shipToEdit = false;
        common.setLoading(false);
        this.prepareInvoiceResponse(response);
        common.showMessage("Entity Changed.");
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async verify() {
    try {
      common.setLoading(true);

      const response = await doGet("/invoice/" + this.invoice._id + "/verify");
      common.setLoading(false);
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  async sendToClient(msgs) {
    try {
      common.setLoading(true);
      const data = { msgs: msgs };
      const response = await doPost(
        "/invoice/" + this.invoice._id + "/send/client",
        data
      );
      common.setLoading(false);
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  async updateStatus() {
    try {
      this.confirmationDialog = false;
      common.setLoading(true);
      const response = await doGet(
        "/api/invoice/" +
          this.invoice._id +
          "/status/" +
          this.invoice.status +
          "/update"
      );
      common.showMessage("Status updated successfully.");
      common.setLoading(false);
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  newItem(itemList) {
    const item = {};
    if (itemList == null) itemList = [];
    itemList.push(item);
    return itemList;
  }

  removeItem(itemList, item) {
    this.remove(itemList, item);
  }

  remove(a, obj) {
    for (let i = 0; i < a.length; i++) {
      if (a[i] === obj) {
        a.splice(i, 1);
      }
    }
  }

  async saveExtraFare() {
    try {
      common.setLoading(true);
      const response = await doPost(
        "/api/invoice/" + this.invoice._id + "/update/fare",
        this.extraFare
      );
      common.showMessage("Status updated successfully.");
      common.setLoading(false);
      common.showMessage("Fare updated successfully.");
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  // printUrl = "/api/invoice/" + this.invoice_id + "/print";
  // summaryPrintUrl = "/api/invoice/" + invoice_id + "/summaryPrint";

  async approveInvoice(msgs) {
    try {
      common.setLoading(true);
      const data = { msgs: msgs };
      const response = await doPost(
        "/invoice/" + this.invoice._id + "/approve",
        data
      );
      common.showMessage("Invoice approved successfully.");
      common.setLoading(false);
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  async saveSubTitle() {
    try {
      common.setLoading(true);
      const data = { subTitle: this.invoice.subTitle };
      const response = await doPost(
        "/api/invoice/" + this.invoice._id + "/updateContent",
        data
      );
      this.editSubTitle = false;
      common.showMessage("Updated successfully");
      common.setLoading(false);
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  async saveSubHeading() {
    try {
      common.setLoading(true);
      const data = { subHeading: this.invoice.subHeading };
      const response = await doPost(
        "/api/invoice/" + this.invoice._id + "/updateContent",
        data
      );
      this.editSubHeading = false;
      this.showMessage("Updated successfully");
      common.setLoading(false);
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  async deleteTripInvoice(tripInvoice) {
    // showConfirmDialog("Do you want to delete this duty(" + tripInvoice.routeNo + ") from invoice?", function () {
    try {
      common.setLoading(true);
      const response = await doGet(
        "/api/invoice/" +
          this.invoice._id +
          "/tripinvoice/" +
          tripInvoice.trip_id +
          "/delete"
      );
      common.showMessage("Trip invoice removed successfully.");
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  // async rejectInvoice(msgs) {
  //   try {
  //     common.setLoading(true);
  //     const data = { msgs: msgs };
  //     const response = await doPost(
  //       "/api/invoice/" + this.invoice._id + "/reject",
  //       data
  //     );
  //     common.showMessage("Invoice rejected.");
  //     this.prepareInvoiceResponse(response);
  //   } catch (e) {
  //     this.setError(e);
  //     common.setLoading(false);
  //   }
  // }

  // async saveInvoice(invoice) {
  //   try {
  //     common.setLoading(true);
  //     const response = await doPost("/api/corp/invoice/save", invoice);
  //     common.showMessage("Invoice rejected.");
  //     this.prepareInvoiceResponse(response);
  //   } catch (e) {
  //     this.setError(e);
  //     common.setLoading(false);
  //   }
  // }

  newItem1(itemList) {
    const item = {};
    if (itemList == null) {
      itemList = [];
    }
    itemList.push(item);
    // $timeout(function () {
    //   applyNumberFiledToClass();
    // }, 25);
    return itemList;
  }

  removeSubItem1(itemList, item) {
    this.remove1(itemList, item);
  }

  remove1(a, obj) {
    for (let i = 0; i < a.length; i++) {
      if (a[i] === obj) {
        a.splice(i, 1);
      }
    }
  }

  showAuditLog(entity, id) {
    // showAuditLogs(entity,id);
  }

  validateCharges(charges) {
    if (!charges || charges.length == 0) return true;
    for (let i = 0; i < charges.length; i++) {
      if (!charges[i].name || charges[i].name.trim() == "") {
        common.setError("All charges name is mandatory.");
        return false;
      }
      if (!charges[i].amount || charges[i].amount == "") {
        common.setError("All charges name is mandatory.");
        return false;
      }
    }
    return true;
  }

  async saveCharges(invoiceId) {
    if (!this.validateCharges(this.invoice.charges)) return;
    try {
      common.setLoading(true);
      this.invoice.invoiceDate = "";
      const t = {};
      t.charges = this.invoice.charges;
      t.discounts = this.invoice.discounts;
      const response = await doPost(
        "/api/invoice/charges/" + invoiceId + "/add",
        t
      );
      common.setLoading(false);
      common.showMessage("Charges added successfully.");
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  async recreateInvoice() {
    // showConfirmDialog("Do you want to recreate this invoice ?", function(){
    try {
      common.setLoading(true);
      const response = await doGet(
        "/api/invoice/" + this.invoice._id + "/recreate"
      );
      common.setLoading(false);
      common.showMessage("Charges added successfully.");
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
    // });
  }

  async deleteCharge(InvoiceId, index, fromCharge) {
    try {
      common.setLoading(true);
      const response = await doGet(
        "/api/invoice/charges/" +
          InvoiceId +
          "/delete/" +
          index +
          "/" +
          fromCharge
      );
      common.showMessage("Charges deleted successfully.");
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  addEditComment() {
    // if(confirm('Do you want to change status ?')) {
    // 	if(! $("#commentTextId").val()){
    // 		showError('Please provide some text.');
    // 		return ;
    // 	}
    // 	$('#commentTextLabelId').text('Comment');
    // 	let cmt = {}
    // 	cmt.msg = $("#commentTextId").val();
    // 	cmt.priority = $("#commentPriority").val();
    // 	cmt.commentsFor = $("#commentFor").val();
    // 	cmt.by = cmt.commentBy = 'Self';
    // 	cmt.at = parseInt(new Date().getTime()/1000);
    //     if(this.commentCallBack != undefined) {
    //       this.commentCallBack(this.selectedInvoice,  this.selectedStatus, cmt);
    //       this.selectedInvoice = null;
    //       this.selectedStatus = null;
    //     } else {
    //       if(!this.invoice.comments)
    //         this.invoice.comments = [];
    //       this.invoice.comments.push(cmt);
    //     }
    // 	$("#adminCommentDialog").modal("hide");
    // }
  }

  getElementAmount(_collect, type) {
    if (
      _collect.elements != null &&
      _collect.elements != undefined &&
      _collect.elements.length > 0
    ) {
      for (let i = 0; i < _collect.elements.length; i++) {
        if (_collect.elements[i].type == type) {
          return _collect.elements[i].amt;
        }
        if (_collect.elements[i].type == type) {
          return _collect.elements[i].amt;
        }
        if (_collect.elements[i].type == type) {
          return _collect.elements[i].amt;
        }
      }
    }
  }

  downloadBookingMIS() {
    window.open(
      "/api/invoice/bookings/download?invoice_id=" + this.invoice._id,
      "_blank"
    );
  }

  downloadDutySlips() {
    const payload = { invoice_ids: this.invoice._id };
    // showPrintDutySlipModal(payload, function(){
    // });
  }

  _showInvoiceEmailModal(_invoice) {
    // let ids = "";
    // let invoiceNos = '';
    // let clientName = '';
    // let vendorName = '';
    // payload = {};
    // payload.invoice_id = this.invoice._id;;
    // payload.invoiceNo = this.invoice.invoiceNo;
    // payload.clientName = this.invoice.clientName;
    // payload.vendorName = this.invoice.vendorName;
    // let emails = [];
    // let distinctEmails = [];
    // for (let i = 0; i < this.invoice.tripInvoices.length; i++) {
    //    if(this.invoice.tripInvoices[i].passengers) {
    //       for (let j = 0; j < this.invoice.tripInvoices[i].passengers.length; j++) {
    //          if (this.invoice.tripInvoices[i].passengers[j].email) {
    //             emails.push(this.invoice.tripInvoices[i].passengers[j].email);
    //          }
    //       }
    //    }
    //    if (this.invoice.tripInvoices[i].passenger && this.invoice.tripInvoices[i].passenger.email) {
    //       emails.push(this.invoice.tripInvoices[i].passenger.email);
    //    }
    // if (this.invoice.tripInvoices[i].bookedBy && this.invoice.tripInvoices[i].bookedBy.email) {
    //   emails.push(this.invoice.tripInvoices[i].bookedBy.email);
    // }
    // }
    // if (emails && emails.length > 0) {
    //    distinctEmails = emails.filter((value, index, self) => {
    //       return self.indexOf(value) === index;
    //    });
    // }
    // payload.emails = distinctEmails;
    // showInvoiceEmailModal(payload, function() {
    // });
  }

  showInvoicePrintModal() {
    // let payload = {};
    //   payload.invoice_ids = this.invoice._id;
    //   payload.client_ids = [];
    //   payload.client_ids.push(this.invoice.client_id);
    // 	payload.vendor_id   = this.invoice.vendor_id;
    //   payload.client_id   = this.invoice.client_id;
    //   payload.vendorEntity_id = this.invoice.vendorEntity._id;
    //   payload.clientEntity_id = this.invoice.clientEntity._id;
    // 	 payload.manual = this.invoice.manual;
    //   showPrintInvoiceTypeModal(payload, function() {
    //   });
  }

  async invoiceDelete(invoice) {
    try {
      common.setLoading(true);
      await doGet("/api/invoice/" + invoice._id + "/delete");
      common.showMessage("Invoice deleted successfully.");
      common.setLoading(false);
      this.$router.push("/sales/invoices");
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async updateLimitedDetails() {
    try {
      const data = {};
      data.invoice_id = this.invoice._id;
      data.invoiceNo = this.invoice.invoiceNo;
      data.invoiceDate = this.invoice.invoiceDate;
      data.submitDate = this.invoice.submitDate;
      data.dueDate = this.invoice.dueDate;
      data.refNo = this.invoice.refNo;
      data.miroNo = this.invoice.miroNo;
      common.setLoading(true);
      const r = await doPost("/api/invoice/limited/details/update", data);
      common.showMessage("Invoice updated successfully.");
      common.setLoading(false);
      this.fetchInvoice(this.invoice._id);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async updateTripsOrdering() {
    try {
      const data = {};
      data.trip_ids = [];
      for (let i = 0; i < this.invoice.tripInvoiceTOS.length; i++) {
        data.trip_ids.push(this.invoice.tripInvoiceTOS[i].trip_id);
      }
      data.trip_ids = data.trip_ids + "";
      common.setLoading(true);
      const r = await doPost("/api/invoice/"+this.invoice._id+"/change/trips/serial", data);
      common.showMessage("Ordering updated successfully.");
      common.setLoading(false);
      this.fetchInvoice(this.invoice._id);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async updateInvoice() {
    const data = {};
    data.invoice_id = this.invoice._id;
    data.invoiceDate = this.invoice.invoiceDate;
    data.invoiceNo = this.invoice.invoiceNo;
    data.vendorEntity_id = this.invoice.vendorEntity._id;
    data.clientEntity_id = this.invoice.clientEntity._id;
    data.shippedEntity_id = this.invoice.shippedEntity._id;
    data.subTitle = this.invoice.subTitle;
    data.subHeading = this.invoice.subHeading;
    data.chargesLabel = this.invoice.chargesLabel;
    data.from = this.invoice.fromDate;
    data.to = this.invoice.toDate;

    if (!data.invoice_id) {
      common.setError("Please select valid Invoice");
      return;
    }
    if (!data.invoiceDate) {
      common.setError("Please enter valid Invoice Date");
      return;
    }
    if (!data.invoiceNo) {
      common.setError("Please enter valid Invoice Number");
      return;
    }
    if (!data.vendorEntity_id) {
      common.setError("Please select valid Invoice Vendor Entity");
      return;
    }
    if (!data.clientEntity_id) {
      common.setError("Please select valid Invoice Client Entity");
      return;
    }
    if (!data.shippedEntity_id) {
      common.setError("Please select valid Invoice Shipped to Entity");
      return;
    }
    // if (!data.from || !data.to) {
    //  common.setError("Please enter duties From and To date");
    //  return;
    // }

    common.setLoading(true);
    try {
      const response = await doPost("/api/invoice/details/update", data);
      common.setLoading(false);
      common.showMessage("Updated successfully.");
      this.prepareInvoiceResponse(response);
    } catch (e) {
      this.setError(e);
      common.setLoading(false);
    }
  }

  async cancelInvoice() {
    this.loading = true;
    try {
      await doGet(`/api/invoice/${this.invoice._id}/cancel`);
      common.showMessage("Invoice cancelled.");
      this.fetchInvoice(this.invoice._id);
      this.loading = false;
    } catch (e) {
      this.loading = false;
      common.setError(e.message);
    }
  }

  moveUp(list, _index) {
    const item = list[_index];
    list.splice(_index, 1);
    list.splice(_index - 1, 0, item);
    for (let i = 0; i < list.length; i++) {
      list[i].index = i + 1;
    }
  }

  getLrNo(tripInvoice) {
    let t = "";
    if (tripInvoice && tripInvoice.cargos && tripInvoice.cargos.length > 0) {
      for (let i = 0; i < tripInvoice.cargos.length; i++) {
        const element = tripInvoice.cargos[i];
        if (element.lr && element.lr.number) {
          t = t + element.lr.number + ",";
        }
      }
    }
    return t;
  }

  getClientLrNo(tripInvoice) {
    let t = "";
    if (tripInvoice && tripInvoice.cargos && tripInvoice.cargos.length > 0) {
      for (let i = 0; i < tripInvoice.cargos.length; i++) {
        const element = tripInvoice.cargos[i];
        if (element.lr && element.lr.clientNo) {
          t = t + element.lr.clientNo + ",";
        }
      }
    }
    return t;
  }

  getClientRefNo(tripInvoice) {
    let t = "";
    if (tripInvoice && tripInvoice.cargos && tripInvoice.cargos.length > 0) {
      for (let i = 0; i < tripInvoice.cargos.length; i++) {
        const element = tripInvoice.cargos[i];
        if (element.clientRefNo) {
          t = t + element.clientRefNo + ",";
        }
      }
    }
    return t;
  }

  getInvNo(tripInvoice) {
    let t = "";
    if (tripInvoice && tripInvoice.cargos && tripInvoice.cargos.length > 0) {
      for (let i = 0; i < tripInvoice.cargos.length; i++) {
        const element = tripInvoice.cargos[i];
        if (element.lr && element.lr.invoiceNo) {
          t = t + element.lr.invoiceNo + ",";
        }
      }
    }
    return t;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
